import React from "react";
import PropTypes from "prop-types";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => {
  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar on the left */}
        <div className="col-md-3 col-lg-2 p-0 bg-light">
          <Sidebar />
        </div>

        {/* Main content area */}
        <div className="col-md-9 col-lg-10 p-0">
          <Header />
          <main className="p-3">{children}</main>
        </div>
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
